/* eslint-disable @typescript-eslint/no-explicit-any */
import { useMutation, MutationFunction, MutationKey } from 'react-query';
import toast from 'react-hot-toast';
import { queryClient } from './react-query';

interface GenericMutationProps {
  func: MutationFunction;
  url: string;
  params?: object;
  customInvalidateQueriesUrl?: string;
  msg: string;
}

const useGenericMutation = ({
  func,
  url,
  params,
  customInvalidateQueriesUrl,
  msg,
}: GenericMutationProps) => {
  return useMutation<unknown, unknown, any, MutationKey>(
    async (data) => {
      return func(data);
    },
    {
      mutationKey: [url, params],
      onMutate: async (data) => {
        return data;
      },

      onError: (err: any, _, context) => {
        toast.error(err?.error?.message, {
          style: {
            background: '#f72f2f',
            color: 'white',
          },
        });

        queryClient.setQueryData([customInvalidateQueriesUrl || url], context);
      },

      onSuccess: () => {
        queryClient.invalidateQueries([customInvalidateQueriesUrl || url]);
        toast.success(msg);
      },
    },
  );
};

export default useGenericMutation;
